import {ConfirmDialog} from "@dvrt/graphql-widgets";
import {showNotification} from "@/actions";
import {defineMessage} from "react-intl";
import {useDeleteAddressBookEntryMutation} from "./queries.generated";
import {useAppDispatch} from "@/hooks";

type Props = {
    cn: string;
    close: () => void;
    target: string;
    onSuccess: () => void;
};

export default ({cn, close, target, onSuccess}: Props) => {
    const [deleteMutation] = useDeleteAddressBookEntryMutation();
    const dispatch = useAppDispatch();

    async function submit() {
        const response = await deleteMutation({
            variables: {
                cn,
                target,
            },
        });

        if (response.data.deleteAddressBookEntry.errors)
            dispatch(
                showNotification(defineMessage({id: "unexpected_error", defaultMessage: "Unexpected error"}), "error"),
            );
        else {
            dispatch(
                showNotification(
                    defineMessage({id: "address_book.deleted", defaultMessage: "Entry deleted"}),
                    "success",
                ),
            );
            onSuccess();
        }
    }

    return (
        <ConfirmDialog
            isOpen={!!cn}
            close={close}
            onConfirm={submit}
            message={defineMessage({
                id: "address_book.delete_confirm",
                defaultMessage: 'Do you really want to remove "{cn}"?',
            })}
            messageVars={{cn}}
            buttonIdPrefix="delete-address-book"
        />
    );
};
